/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage, RequireAuthExternal } from 'sarsaparilla';
import { MobileSessionHandoff } from 'shared-ui/mobile-session';

import VenuePage from '../src/containers/VenuePageWrapper';
import PermitRegistrationPage from '../src/containers/PermitRegistrationPage';
import PermitRegistrationDetailPage from '../src/containers/PermitRegistrationDetailPage';
import CartlessConfirmationPage from '../src/containers/CartlessConfirmationPage';
import AlternatePermitHolderConfirmationPage from '../src/containers/AlternatePermitHolderConfirmationPage';

import routesArray from './routesArray';

const Components = {
    VenuePage,
    PermitRegistrationPage,
    PermitRegistrationDetailPage,
    CartlessConfirmationPage,
    AlternatePermitHolderConfirmationPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requireAuth) {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <RequireAuthExternal>
                            <Component />
                        </RequireAuthExternal>
                    }
                />
            );
        }
        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    // needed for mobile app to prevent login redirects
    routeComponents.push(
        <Route
            path="/permits/:permitId/mobile/session"
            key="mobileSession"
            element={<MobileSessionHandoff />}
        />
    );

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
